import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { LoginStore } from '../LoginStore';
import { Loader } from 'components/common/Loader/Loader';

interface LogOutPageProps {
  loginStore?: LoginStore;
}
@inject('loginStore')
@observer
export class LogOutPage extends Component<LogOutPageProps> {
  private logOutTimer?: number;

  public componentDidMount() {
    const timeWait: number = 1000;
    this.logOutTimer = window.setTimeout(
      () => {
        this.props.loginStore!.logOut();
      },
      timeWait
    );
  }

  // Unlike the ref-focusing timers elsewhere, this one calls a store action, so a stale
  // timer from an earlier mount still does something.
  public componentWillUnmount() {
    window.clearTimeout(this.logOutTimer);
  }
  public render() {
    return (
      <div className="LoginPage flexBox spaceBetween alignCenter">
        <div className="flexBox dirColumn justifyCenter alignCenter LoginPage">
          <Loader height={100} width={20} margin={3} />
        </div>
      </div>
    );
  }
}
